import { InjectionToken } from '@angular/core';

export const JMIX_UI_URL = new InjectionToken<string>('JMIX_UI_URL');
export const PYTHON_URL = new InjectionToken<string>('PYTHON_URL');
